import React from 'react';
import { motion } from 'framer-motion';
import { Box, Container, Typography, Grid, Button, Paper, Chip } from '@mui/material';

export default function About() {
  return (
    <Box component="section" id="about" sx={{ py: { xs: 10, md: 12 } }}>
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} lg={6}>
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <Chip
                label="About Us"
                sx={{
                  mb: 2,
                  bgcolor: 'rgba(30, 91, 92, 0.1)',
                  color: 'rgba(30, 91, 92, 1)',
                  fontWeight: 500
                }}
              />
              <Typography
                variant="h3"
                component="h2"
                sx={{ fontWeight: 'bold', mb: 3, fontSize: { xs: '2rem', md: '2.5rem' } }}
              >
                Your Trusted Taxation And Loan Expert
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: 'text.secondary', mb: 3, lineHeight: 1.7 }}
              >
                Shree Consultancy is advisory firm provide expert services in
                Income Tax, Goods and Services Tax and Business Loan based in
                Rajkot. Our approach is to provide value added services to
                client.
              </Typography>
              <Button
                variant="contained"
                size="large"
                href="#contact"
                sx={{
                  bgcolor: 'rgba(30, 91, 92, 1)',
                  '&:hover': { bgcolor: 'rgba(30, 91, 92, 0.8)' },
                  py: 1.5,
                  px: 3
                }}
              >
                Contact Us Now
              </Button>
            </motion.div>
          </Grid>

          <Grid item xs={12} lg={6}>
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <Paper
                elevation={8}
                sx={{
                  height: 500,
                  borderRadius: 2,
                  overflow: 'hidden',
                  backgroundImage: 'url(https://images.pexels.com/photos/34811873/pexels-photo-34811873.jpeg?auto=compress&w=800)',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}
              />
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}